var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 7.58333V6.25C14.6673 5.89638 14.5268 5.55724 14.2768 5.30719C14.0267 5.05714 13.6876 4.91667 13.334 4.91667H11.834V3.58333C11.8335 3.09727 11.6401 2.63126 11.2964 2.28756C10.9527 1.94385 10.4867 1.75053 10.0007 1.75H6.00065C5.51458 1.75053 5.04858 1.94385 4.70487 2.28756C4.36117 2.63126 4.16785 3.09727 4.16732 3.58333V4.91667H2.66732C2.3137 4.91667 1.97456 5.05714 1.72451 5.30719C1.47446 5.55724 1.33398 5.89638 1.33398 6.25V7.58333L8.00065 10.25L14.6673 7.58333ZM5.16732 3.58333C5.16732 3.12333 5.54065 2.75 6.00065 2.75H10.0007C10.4607 2.75 10.834 3.12333 10.834 3.58333V4.91667H5.16732V3.58333Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 12.9162V8.66016L8.00065 11.3268L14.6673 8.66016V12.9162C14.6673 13.2698 14.5268 13.6089 14.2768 13.859C14.0267 14.109 13.6876 14.2495 13.334 14.2495H2.66732C2.3137 14.2495 1.97456 14.109 1.72451 13.859C1.47446 13.6089 1.33398 13.2698 1.33398 12.9162Z",
    fill: "#EECC41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.43ecc9b9.svg";
export { ForwardRef as ReactComponent };